import { Box, FormField, Input, Text } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import type { LogBiFn } from './../../_shared/bi-context-provider/bi-context-provider';
import type { PmActionButtonNode, PmLinkButtonNode } from './../../_shared/pm-node-types';

import { GENERAL_SETTINGS_BUTTON_TEXT_INPUT } from '../data-hooks';
import classes from '../statics/styles/settings-component-scss';

type SettingsComponentProps = {
  buttonData: (PmLinkButtonNode | PmActionButtonNode)['attrs'];
  onChange: (data: Partial<(PmLinkButtonNode | PmActionButtonNode)['attrs']>) => void;
  logBi: LogBiFn;
};

export const SettingsComponent: React.FC<SettingsComponentProps> = ({
  buttonData,
  onChange,
  logBi,
}) => {
  const { t } = useContext(RicosContext);

  return (
    <Box
      direction="vertical"
      gap="SP3"
      padding="SP3"
      paddingTop="SP4"
      width="100%"
      className={classes.formField}
    >
      <FormField
        label={
          <Text size="small" secondary>
            {t('ButtonModal_Button_Text')}
          </Text>
        }
      >
        <Input
          type="text"
          onChange={e => {
            onChange({ ...buttonData, text: e.target.value });
            logBi({ dataHook: GENERAL_SETTINGS_BUTTON_TEXT_INPUT, value: e.target.value });
          }}
          value={buttonData.text ?? undefined}
          dataHook={GENERAL_SETTINGS_BUTTON_TEXT_INPUT}
          placeholder={t('ButtonModal_InputName_Placeholder')}
          size="small"
          textOverflow="ellipsis"
        />
      </FormField>
    </Box>
  );
};
